<template>
  <BreadCrumb PageTitle="Détails sur les questions" />
  <ViewQuestion />
</template>

<script lang="ts">
  import { defineComponent } from "vue";

  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import ViewQuestion from "@/components/Question/ViewQuestion.vue";

  export default defineComponent({
    name: "ViewQuestionPage",
    components: {
      BreadCrumb,
      ViewQuestion,
    },
  });
</script>